import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../core/auth'
import type { UserRole } from '../types'

export function ProtectedPortal({ role, children }: { role: UserRole; children: ReactNode }) {
  const { user, loading } = useAuth()
  if (loading) return <main className="auth-loading"><span className="loading-ring" /><p>계정 권한을 확인하고 있습니다.</p></main>
  if (!user || !user.roles.includes(role)) {
    const login = role === 'super_admin' ? '/super-admin/login' : role === 'hospital_admin' ? '/hospital-admin/login' : '/member/login'
    return <Navigate to={login} replace />
  }
  return <>{children}</>
}
